import module from 'kendu/legacy/module'
import { forEach } from 'lodash'

module.directive('uiAsyncValidators', () => ({
  restrict: 'A',
  require: 'ngModel',
  link (scope, element, attrs, ngModel) {
    let validators = scope.$eval(attrs['uiAsyncValidators'])

    forEach(validators, (value, key) => (ngModel.$asyncValidators[key] = value))
  },
}))



// WEBPACK FOOTER //
// ./src/deprecated/directive/ui-async-validator/component.js